class gTagEvents {
    constructor() {      
      this.delegateBody = new Delegate(document.body);

      this.bindEvents();
      this.observeDOMChanges();
      this.handleIntersects();

      this.interceptCartApi();
    }
  
    bindEvents() {
      this.delegateBody.on("click", "button[name='checkout']", this.handleCheckout.bind(this));
      this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
          // For each mutation record, we look for added nodes
          for (const mutation of mutationsList) {
            if (mutation.addedNodes.length) {
              // If there are added nodes, we call handleIntersects to check for new items
              this.handleIntersects();
            }
          }
        });
    
        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
          childList: true, // Observe direct children
          subtree: true, // and all descendants
          attributes: false // Set to true if you also want to observe attribute changes
        });
      }
  
    handleIntersects() {
      const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');
  
      allIntersections.forEach((item) => {
        const observer = new IntersectionObserver(
            this.handleIntersection.bind(this),
            {
              root: null, // Use the viewport as the root
              rootMargin: "0px",
              threshold: 0.1, // Adjust the threshold as per your requirement
            }
          );
  
          observer.observe(item);
          item.dataset.observed = "true";
      });
    }
  
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let data = false;
  
          try {
            data = JSON.parse(
              entry.target.querySelector('script[type="application/ld+json"]').textContent
            );

          } catch(e) {
            console.log("JSON parse failed", e);
          }

          console.log(entry, "observed");
  
          if (!dataLayer || !data) return;

          dataLayer.push({ ecommerce: null });
          dataLayer.push(data);

          console.log(data, "And pushed to dataLayer");
        }
      });
    }


    interceptCartApi() {
      const originalFetch = window.fetch;
      const _this = this;

      window.fetch = async function (...args) {
        try {
          const [url] = args;
          
          if (url.includes(`/cart/clear.js`)) _this.cartClear();

          const response = await originalFetch.apply(this, args);          
          if (url === '' || !dataLayer || !response.ok) return response;
  
          if (url.includes(`/cart/add.js`)) {          
            _this.cartAdd(response);
  
          } else if (url.includes(`/cart/change.js`) || url.includes(`/cart/update.js`)) {
            _this.cartUpdate(response);
          }
  
          return response;

        } catch(e) {          
          return originalFetch(...args);
        }
      };
    }

    async cartAdd(response) {
      const cart = await response.json();
      this.productAdded(cart.items);
    }

    async cartUpdate(response) {      
      console.log("response", response);
      
      const cart = await response.json();
      
      this.productAdded(cart.items_added);
      this.productsRemoved(cart.items_removed);
    }

    async cartClear() {
      const cart = await this.getCart();      
      this.productsRemoved(cart.items);
    }

    async getCart() {
      try {
        const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });
      
        return await response.json();

      } catch (error) {
        console.log('Fetch Error:', error);
      }
    }

    productAdded(cartItems) {
      if (!cartItems.length) return;

      const items = [];
      let totalPrice = 0;
      
      cartItems.forEach(item => {
        const price = Shopify.formatMoney(item.price, '{{amount}}');
        totalPrice += price;

        items.push({
          'item_id': item.sku,
          'item_variant': item.variant_title,
          'item_name': item.product_title,
          'price': price,
          'quantity': item.quantity
        })
      })

      dataLayer.push({ ecommerce: null });  
      dataLayer.push({
        'event': 'add_to_cart_custom', 
        'ecommerce': {
        'value': parseInt(totalPrice),
        'items': items
        }
      });

      console.log("dataLayer push -> added:", items);
    }

    async productsRemoved(cartItems) {
      if (!cartItems.length) return;

      const items = [];
      let totalPrice = 0;

      cartItems.forEach(item => {
        const price = Shopify.formatMoney(item.price, '{{amount}}');
        totalPrice += price;

        items.push({
          'item_id': item.sku,
          'item_variant': item.variant_title,
          'item_name': item.product_title,
          'price': price,
          'quantity': item.quantity
        })
      })

      dataLayer.push({
        event: "remove_from_cart",
        remove: {
          value: totalPrice, 
          items: items
        },
      });

      console.log("dataLayer push -> removed:", items);
    }
  
    handleCheckout() {      
      const button = event.target.closest("button[name='checkout']");
      if (!button) return;

      const script = button.parentElement.querySelector('[type="application/ld+json"]');
      const settings = JSON.parse(script.innerText);
  
      if (!dataLayer || !settings) return;
  
      dataLayer.push({ ecommerce: null });
      dataLayer.push(settings);
  
      console.log("checkoutFired", settings);
    }
  
    handleSelectItem(event) {
      let target = event.target.closest('[data-action="ga-send-select"]');
      if (!target || !dataLayer) return;
  
      const settings = JSON.parse(target.dataset.selectSettings);
      if (!settings) return;
  
      dataLayer.push({
        event: "select_item",
        selected_item_list_id: settings.list_id,
        selected_item_list_name: settings.list_name,
        selected_items: [
          {
            item_id: settings.item_id,
            item_name: settings.item_name,
            price: settings.price,
            item_list_id: settings.list_id,
            item_list_name: settings.list_name,
          },
        ],
      });
    }
}

new gTagEvents();